import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Drawer-open",
  "use": "Drawer-open-usage",
  "viewBox": "0 0 32 20",
  "content": "<symbol viewBox=\"0 0 32 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Drawer-open\">\n<path d=\"M3.76 -1.23441e-06L16 12.2133L28.24 -1.64355e-07L32 3.76L16 19.76L-1.11803e-06 3.76L3.76 -1.23441e-06Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol